import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export function MaskedLines({ lines, delay = 0, className = '', inView = false, as = 'h2' }) {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: '-60px' });
  const active = inView ? seen : true;
  const Tag = as;
  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: '112%' }}
            animate={active ? { y: '0%' } : { y: '112%' }}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.13 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, y = 28, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-3 font-mono text-xs font-bold uppercase tracking-[0.3em] ${className}`}>
      <span className="h-px w-8 bg-current" />
      {children}
    </span>
  );
}
